
import FormConsent from '@/components/forms/FormConsent.vue';
import AddressStore from '@/store/addressStore';
import { ConfigInterface, CustomerPersonData, InvestmentPersonData } from '@/store/types';
import {
  FormFieldAddress, FormFieldBirthNumber, FormFieldCheckbox, FormFieldEmail, FormFieldFirstname, FormFieldIco, FormFieldIdentityCard, FormFieldLastname, FormFieldPhone,
} from '@cfg/cfg-utilities-fe';
import { PropType } from 'vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { required } from '@/helpers/inputRules';

@Component({
  components: {
    FormFieldFirstname,
    FormFieldLastname,
    FormFieldBirthNumber,
    FormFieldAddress,
    FormFieldEmail,
    FormFieldPhone,
    FormFieldIdentityCard,
    FormFieldIco,
    FormFieldCheckbox,
    FormConsent,
  },
  methods: { required },
})
export default class FormPersonalData extends Vue {
  // PROPS
  @Prop({ type: Object as PropType<CustomerPersonData | InvestmentPersonData>, default: () => ({}) }) readonly person!: CustomerPersonData | InvestmentPersonData;

  @Prop({ type: Object as PropType<ConfigInterface>, default: null }) readonly config!: ConfigInterface;

  // TODO: move this to 'config' @Prop
  @Prop({ type: Boolean, default: false }) readonly showSelfEmployedId!: boolean;

  // VUEX MODULES
  addressStore: AddressStore | null = null;

  // Getter and setter for address. Converting SuggestedAddress to Address and vice versa
  get permanentAddress(): string {
    return this.person.permanentAddress?.whole_address || '';
  }

  set permanentAddress(address: string) {
    this.$emit('update:field', {
      field: 'permanentAddress',
      value: {
        whole_address: address,
      },
    });
  }

  // HOOKS
  created() {
    this.addressStore = getModule(AddressStore);
  }
}
